import { useEffect } from 'react';
import Protect from 'hocs/Protect';
import ProfileHeader from 'pages/profile/components/ProfileHeader';
import ProfileNotifications from 'pages/profile/components/ProfileNotifications';
import ProfileTabMenu from 'pages/profile/components/ProfileTabMenu';
import ProfileTabs from 'pages/profile/components/ProfileTabs';
import useProfilePage from 'pages/profile/hooks/useProfilePage';
import classes from './index.module.scss';
import { PROFILE_TABS } from './utils';
import { useLandaRouter } from 'hooks/logics/useLandaRouter';

const ProfilePage = () => {
  const { params } = useLandaRouter();
  const {
    selectedTab,
    setSelectedTab,
    chosenTab,
    chosenTabMenu,
    filteredTabs,
    onChangeTab,
    onChangeMenuTab,
  } = useProfilePage();

  const DynamicComponent = chosenTabMenu.component;

  useEffect(() => {
    switch (params.tab) {
      case 'Support':
        setSelectedTab(PROFILE_TABS.HELP_AND_SUPPORT);
        onChangeTab({ value: PROFILE_TABS.HELP_AND_SUPPORT });
        break;
      case 'BankAndTransfer':
        setSelectedTab(PROFILE_TABS.BANK_AND_TRANSFERS);
        onChangeTab({ value: PROFILE_TABS.BANK_AND_TRANSFERS });
        break;
      default:
        setSelectedTab(PROFILE_TABS.ACCOUNT);
        onChangeTab({ value: PROFILE_TABS.ACCOUNT });
        break;
    }
  }, [params]);

  return (
    <div className={classes.container}>
      <ProfileHeader className={classes.header} />
      <ProfileNotifications className={classes.notification} />
      <ProfileTabs
        className={classes.topTabs}
        onChangeTab={onChangeTab}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <div className={classes.bottomSection}>
        <ProfileTabMenu
          className={classes.tabMenu}
          chosenTab={chosenTab}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          onChangeMenuTab={onChangeMenuTab}
          filteredTabs={filteredTabs}
        />
        <div className={classes.content}>
          <DynamicComponent />
        </div>
      </div>
    </div>
  );
};

export default Protect(ProfilePage);
